import React from 'react';
// eslint-disable-next-line import-x/no-extraneous-dependencies
import { useDateFormatter } from 'react-aria';

import type { DateFormatterOptions } from 'react-aria';

type DateFormatterProps = {
  children: Date;

  className?: string;

  /** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#:~:text=options,-Optional */
  options?: DateFormatterOptions;
};

/**
 * @see {@link https://craigbuckler.com/intl Intl format playground}
 */
export const DateFormatter = ({ children, className, options }: DateFormatterProps) => {
  const formatter = useDateFormatter(options);

  return (
    <time dateTime={children.toISOString()} className={className}>
      {formatter.format(children)}
    </time>
  );
};
